import { format } from 'date-fns';

// Truncate description text
export const truncateDescription = (description, maxLength = 100) => {
    if (!description) return '';
    if (description.length <= maxLength) return description;
    return description.substring(0, maxLength) + '...';
};

// Format date for display
export const formatAchievementDate = (date) => {
    if (!date) return '';
    return format(new Date(date), 'dd-MM-yyyy');
};

// Calculate pagination values
export const calculatePagination = (items, currentPage, itemsPerPage) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(items.length / itemsPerPage);

    return {
        currentItems,
        totalPages,
        indexOfFirstItem,
        indexOfLastItem
    };
};

// Check if element has horizontal overflow
export const checkHorizontalOverflow = (element) => {
    if (!element) return false;
    return element.scrollWidth > element.clientWidth;
};

// Generate wave animation styles
export const getWaveAnimationStyles = (isClicked) => {
    if (!isClicked) return {};

    return {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '20px',
            height: '20px',
            background: 'rgba(59, 130, 246, 0.2)',
            borderRadius: '50%',
            transform: 'translate(-50%, -50%) scale(0)',
            animation: 'wave 0.3s ease-out',
            pointerEvents: 'none',
            zIndex: 1,
        },
        '@keyframes wave': {
            '0%': {
                transform: 'translate(-50%, -50%) scale(0)',
                opacity: 1,
            },
            '100%': {
                transform: 'translate(-50%, -50%) scale(8)',
                opacity: 0,
            },
        },
    };
};

// Get achievement image with fallback
export const getAchievementImage = (signedThumbnailUrl, thumbnailUrl, fallbackImage) => {
    return signedThumbnailUrl || thumbnailUrl || fallbackImage;
}; 